/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import {put,call,takeLatest} from 'redux-saga/effects';
import { EDIT_EMP, ADD_EMP, GET_EMP,
  SEARCH_EMP, DELETE_EMP, UPLOAD_BULK_EMP } from '../action/constant';
import request from '../utils/request';
import { addEmpSuccess, addEmpError,
   getEmpSuccess, getEmpError, deleteEmpSuccess,
   getEmpRequest, deleteEmpError, editEmpSuccess,
   editEmpError,
   uploadBulkEmpError,
   uploadBulkEmpSuccess} from '../action/EmpAction';

const token = localStorage.getItem('token');

function* addEmpSaga(action){
  const url=`Employee/addemp`;
  const data = JSON.parse(localStorage.getItem('building'));
  const obj = {
    name:action.data.name,
    department:action.data.department,
    phone_number:action.data.phoneNumber,
    email:action.data.email,
    buildingId:data._id,
  }
  try{
    const response = yield call(request,url,{
      method:'POST',
      headers:{
        Accept:'applicatin/json',
        Authorization:`VMS-2.0${token}`,
      },
      data:obj
    });
    yield put(addEmpSuccess(response.data.employee))
  }
  catch(err){
   yield put(addEmpError(err.response.data))
  }
}

function* editEmpSaga(action) {
  const url = `Employee/edit?id=${action.data.id}`;
  try{
    const response = yield call(request,url,{
      method:'PUT',
      headers:{
        Accept:'application/json',
        Authorization:`VMS-2.0${token}`,
      },
      data:action.data.formValue,
    });
    yield put(editEmpSuccess(response.data));
    yield put(getEmpRequest());
  }
  catch(err){
   yield put(editEmpError(err.response.data));
  }
}

function* getEmpSaga(action) {
const data = JSON.parse(localStorage.getItem('building'));
const url =`Employee/searchall?buildingId=${data._id}&search=${action.data.search || ''}&page=${action.data.page || 1}&limit=${action.data.sizePerPage || 10} `;
try{
 const response = yield call(request,url,{
   method:'GET',
   headers:{
     Accept:'application/json',
     Authorization:`VMS-2.0${token}`,
   },
 });
 yield put(getEmpSuccess(response.data))
}
catch(err){
 yield put(getEmpError(err.response.data))
}
}

function* deleteEmpSaga(action){
  const url = `Employee/delete?id=${action.data}`;
  try{
    const response = yield call(request,url,{
      method:'PUT',
      headers:{
        Accept:'application/json',
        Authorization:`VMS-2.0${token}`,
      }
    });
    yield put(deleteEmpSuccess(response.data));
    yield put(getEmpRequest({search:''}));
  }
  catch(err){
     yield put(deleteEmpError(err.response.data));
  }
}
function* uploadBulkEmpSaga(action){
  const data = JSON.parse(localStorage.getItem('building'));
  const url = `Employee/upload?buildingId=${data._id}`;
  const fd = new FormData();
   fd.append('file',action.data);
  try{
     const response = yield call(request,url,{
       method:'POST',
       headers:{
         Accept:'application/json',
         Authorization:`VMS-2.0${token}`,
       },
       data:fd
     });
    yield put(uploadBulkEmpSuccess(response.data));
  }
catch(err){
  yield put(uploadBulkEmpError(err.response.data));
}
}
export default function* addEmpWatcherSaga(){
  yield takeLatest(DELETE_EMP.PENDING,deleteEmpSaga);
  yield takeLatest(ADD_EMP.PENDING,addEmpSaga);
  yield takeLatest(EDIT_EMP.PENDING,editEmpSaga);
  yield takeLatest(GET_EMP.PENDING,getEmpSaga);
  yield takeLatest(SEARCH_EMP.PENDING,getEmpSaga);
  yield takeLatest(UPLOAD_BULK_EMP.PENDING,uploadBulkEmpSaga);
}
